<template>
  <div class="dashboard">
    <div class="row row-equal">
      <div class="flex xl12 xs12">
        <div class="row">
          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='success'>
              <p v-if='$apollo.queries.clients.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{clients.aggregate.count}}</p>
              <p>Clientes</p>
            </va-card>
          </div>
          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='danger'>
              <p v-if='$apollo.queries.posts.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{posts.aggregate.count}}</p>
              <p>Postagens</p>
            </va-card>
          </div>
        </div>
        <div class="row">
          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='dark'>
              <p v-if='$apollo.queries.membros.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{membros.aggregate.count}}</p>
              <p>Membros S1Live Ativos</p>
            </va-card>
          </div>

          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='primary'>
              <p v-if='$apollo.queries.membrosTrial.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{membrosTrial.aggregate.count}}</p>
              <p>Membros S1Live Trial</p>
            </va-card>
          </div>
          <!--<div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='primary'>
              <p v-if='$apollo.queries.transmissoes.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{transmissoes.aggregate.count}}</p>
              <p>Transmissões</p>
            </va-card>
          </div>-->
        </div>
        <div class="row">
          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='grey'>
              <p v-if='$apollo.queries.membrosInativos.loading' class="display-2 mb-0" style="color: white;">...</p>
              <p v-else class="display-2 mb-0" style="color: white;">{{membrosInativos.aggregate.count}}</p>
              <p>Membros S1Live que Não Renovaram</p>
            </va-card>
          </div>
          <div
            class="flex xs12 sm6"
          >
            <va-card class="mb-4" color='black' v-if='!$apollo.queries.order.loading'>
              <p class="display-2 mb-0" style="color: white;">
                <span v-for="(data, id) in order" :key="id">
                  {{ data.total }} {{ id === order.length - 1 ? '' : '|' }}
                </span>
              </p>
              <p>
                <span v-for="(data, id) in order" :key="id">
                  {{ data.name }} {{ id === order.length - 1 ? '' : '|' }}
                </span>
              </p>
            </va-card>
          </div>
        </div>
      </div>
    </div>
    <div class="row row-equal">
      <div class="flex xl6 lg6 xs12 sm12">
        <pagamentos/>
      </div>
      <div class="flex xl6 lg6 xs12 sm12">
        <assinaturas/>
      </div>
    </div>
    <div class="row row-equal">
      <div class="flex xl12 xs12 sm12">
        <subs />
      </div>
      <!-- </div> -->
    </div>
    <div class="row row-equal">
      <!-- <div class="flex xl6 xs12"> -->
      <div class="flex xl6 lg6 xs12 sm12">
        <rank/>
      </div>
      <!-- </div> -->
      <!-- <div class="flex xl6 xs12"> -->
      <div class="flex xl6 lg6 xs12 sm12">
        <player />
      </div>
      <!-- </div> -->
    </div>
    <div class="row row-equal">
      <div class="flex xl12 xs12 sm12">
        <week />
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Rank from './items/rank.vue'
import Player from './items/player.vue'
import Week from './items/week.vue'
import Pagamentos from './items/pagamentos.vue'
import Assinaturas from './items/assinaturas.vue'
import Subs from './items/subs.vue'
export default {
  name: 'dashboard',
  components: {
    Rank,
    Player,
    Week,
    Pagamentos,
    Assinaturas,
    Subs,
  },
  data () {
    return {
      posts: {},
      clients: {},
      membros: {},
      membrosTrial: {},
      membrosInativos: {},
      //  transmissoes: {},
      order: {},
    }
  },
  apollo: {
    clients: gql`
    query MyQuery {
      clients: client_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
    posts: gql`
    query MyQuery {
      posts: post_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
    membros: gql`
    query MyQuery {
      membros: contracted_plan_aggregate(where: {active: {_eq: true}, invoice: {gateway: {_neq: "TRIAL"}}}) {
        aggregate {
          count(distinct: true, columns: [client_id])
        }
      }
    }
    `,
    membrosTrial: gql`
    query MyQuery {
      membrosTrial: contracted_plan_aggregate(where: {active: {_eq: true}, invoice: {gateway: {_eq: "TRIAL"}}}) {
        aggregate {
          count(distinct: true, columns: [client_id])
        }
      }
    }
    `,
    membrosInativos: gql`
    query MyQuery {
      membrosInativos: client_inactive_aggregate{
        aggregate{
          count
        }
      }
    }
    `,
    /*  transmissoes: gql`
    query MyQuery {
      transmissoes: transmission_aggregate {
        aggregate {
          count
        }
      }
    }
    `, */
    order: gql`
    query MyQuery {
      order: order_status_count(order_by: {order_status_id: asc}) {
        order_status_id
        name
        total
      }
    }
    `,
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }

  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
